import axios from 'axios'

const loginUser = async (passcode) => {
    const BASE_URL = process.env.REACT_APP_API_BASE_URL

    try {
        const res = await axios.post(
            `${BASE_URL}/login`,
            { passcode },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        )
        return {token: res.data.token}
    } catch (err) {
        return {error: err.response?.data?.error || 'Server error'}
    }
}

export default loginUser